import qs from 'qs';
import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { object, string, ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { envDomain } from '@itm/shared-frontend/lib/utils';
import { Field } from '@itm/shared-frontend/lib/components/forms';
import { BaseModal } from '@itm/shared-frontend/lib/components/modals';
import { LoadingButton } from '@itm/shared-frontend/lib/components/buttons';

import { AUTH_API_URL } from 'src/utils/constants';

import { OktaIcon } from 'src/components/icons';

type FormData = {
  email: string;
};

const formSchema: ObjectSchema<FormData> = object({
  email: string().label('Email').trim().lowercase().required().email(),
});

function SsoOktaButton() {
  const [isShowModal, setIsShowModal] = useState(false);

  const { register, control, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = handleSubmit(async ({ email }) => {
    // Redirect to SSO Init endpoint which will redirect to Okta
    globalThis.location.href = `${AUTH_API_URL}/auth/sso/initiate/okta?${qs.stringify({ email, domain: envDomain })}`;
  });

  const closeModalHandler = () => {
    setIsShowModal(false);
    reset();
  };

  return (
    <>
      <button
        type="button"
        className="button is-grey is-outlined is-fullwidth mb-3"
        onClick={() => setIsShowModal(true)}
      >
        <span className="icon">
          <OktaIcon />
        </span>
        <span>Sign in with Okta</span>
      </button>

      <BaseModal
        isShowModal={isShowModal}
        closeModal={closeModalHandler}
        Header={<p className="modal-card-title has-text-centered has-text-weight-medium">Sign in with Okta</p>}
        Body={
          <div className="is-size-3">
            <p className="mb-5">Please provide your email.</p>
            <form
              id="oktaModalForm"
              className="columns is-justify-content-center has-text-left"
              onSubmit={onSubmit}
              noValidate
            >
              <div className="column is-8">
                <Field
                  label="Email"
                  field="input"
                  type="email"
                  placeholder="Enter email"
                  autoComplete="email"
                  register={register('email')}
                  control={control}
                  formSchema={formSchema}
                  errors={formState.errors}
                  autoFocus
                />
              </div>
            </form>
          </div>
        }
        Footer={
          <>
            <LoadingButton
              className="button is-interact"
              type={isShowModal ? 'submit' : 'button'}
              form="oktaModalForm"
              minTime={1000}
              isLoading={formState.isSubmitting}
            >
              Sign in
            </LoadingButton>
            <button className="button is-grey is-outlined" type="button" onClick={closeModalHandler}>
              Cancel
            </button>
          </>
        }
      />
    </>
  );
}

export default SsoOktaButton;
